export const footballPromoContent = {
    fr: {
        badge: 'Ligue 1 · UEFA Champions League · Liguee1',
        titleLine1: 'Le meilleur du football européen',
        titleAccent: 'en direct et en 4K',
        body: 'Ligue 1, Champions League et tous les grands clubs européens, chaque semaine, sans coupure, sur tous vos appareils.',
        features: ['Tous les clubs', 'Tous les appareils', 'Activation en 1 min'],
        cta: 'Commander maintenant',
        security: 'Support 24/7 · Paiement 100% sécurisé',
        offerExpires: "L'offre expire dans",
        hours: 'Heures',
        minutes: 'Min',
        seconds: 'Sec',
        leagueLogoAlt: 'Ligue 1',
    },
    es: {
        badge: 'LaLiga · UEFA Champions League · Liguee1',
        titleLine1: 'Lo mejor del fútbol europeo',
        titleAccent: 'en directo y en 4K',
        body: 'LaLiga, la Champions League y todos los grandes clubes europeos, cada semana, sin cortes, en todos tus dispositivos.',
        features: ['Todos los clubes', 'Todos los dispositivos', 'Activación en 1 min'],
        cta: 'Pedir ahora',
        security: 'Soporte 24/7 · Pago 100% seguro',
        offerExpires: 'La oferta termina en',
        hours: 'Horas',
        minutes: 'Min',
        seconds: 'Seg',
        leagueLogoAlt: 'La Liga',
    },
};
